// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =================================
   TABLE
================================= */

.e2e_hotlist_table_wrapper{

  overflow-x:auto;
}

/* TABLE */

.e2e_hotlist_table_wrapper table{

  width:100%;

  border-collapse:separate;

  border-spacing:0 14px;
}

/* TABLE HEADER */

.e2e_hotlist_table_wrapper thead th{

  background:#f8fafc;

  padding:18px;

  font-size:13px;

  font-weight:800;

  text-transform:uppercase;

  color:#475569;

  border-top:1px solid #e2e8f0;

  border-bottom:1px solid #e2e8f0;

  text-align:left;
}

/* BODY ROW */

.e2e_hotlist_table_wrapper tbody tr{

  background:white;

  transition:0.3s ease;

  box-shadow:
    0 4px 15px rgba(15,23,42,0.04);
}

.e2e_hotlist_table_wrapper tbody tr:hover{

  transform:translateY(-2px);

  box-shadow:
    0 10px 24px rgba(15,23,42,0.08);
}

/* TABLE CELLS */

.e2e_hotlist_table_wrapper td{

  padding:20px 18px;

  vertical-align:middle;

  font-size:14px;

  color:#1e293b;

  font-weight:600;

  border-top:1px solid #f1f5f9;

  border-bottom:1px solid #f1f5f9;
}

/* COLUMN WIDTHS */

.e2e_hotlist_table_wrapper td:nth-child(1){

  width:60px;

  text-align:center;

  font-weight:800;

  color:#2563eb;
}

.e2e_hotlist_table_wrapper td:nth-child(2){

  width:34%;
}

.e2e_hotlist_table_wrapper td:nth-child(3){

  width:22%;

  color:#0f172a;

  font-weight:700;
}

.e2e_hotlist_table_wrapper td:nth-child(4){

  width:25%;
}

.e2e_hotlist_table_wrapper td:nth-child(5){

  width:140px;

  text-align:center;
}

/* RADIUS */

.e2e_hotlist_table_wrapper tbody tr td:first-child{

  border-left:1px solid #f1f5f9;

  border-top-left-radius:18px;

  border-bottom-left-radius:18px;
}

.e2e_hotlist_table_wrapper tbody tr td:last-child{

  border-right:1px solid #f1f5f9;

  border-top-right-radius:18px;

  border-bottom-right-radius:18px;
}

/* DETAILS */

.e2e_hotlist_details{

  display:flex;

  flex-direction:column;

  gap:10px;
}

.e2e_hotlist_details p{

  margin:0;

  line-height:1.5;

  color:#475569;
}

.e2e_hotlist_details strong{

  color:#0f172a;

  margin-left:6px;
}

/* LOCATION */

.e2e_hotlist_location{

  display:flex;

  flex-direction:column;

  gap:12px;
}

.e2e_hotlist_location p{

  margin:0;

  line-height:1.5;

  color:#475569;
}

.e2e_hotlist_location strong{

  color:#0f172a;

  margin-left:6px;
}

/* ACTIONS */

.e2e_hotlist_actions{

  display:flex;

  flex-direction:column;

  align-items:center;

  justify-content:center;

  gap:10px;
}

/* BUTTONS */

.viewBtn,
.editBtn,
.deleteBtn{

  border:none;

  width:90px;

  height:38px;

  border-radius:12px;

  font-size:12px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;
}

/* VIEW */

.viewBtn{

  background:#dbeafe;

  color:#2563eb;
}

.viewBtn:hover{

  background:#2563eb;

  color:white;
}

/* EDIT */

.editBtn{

  background:#fef3c7;

  color:#d97706;
}

.editBtn:hover{

  background:#f59e0b;

  color:white;
}

/* DELETE */

.deleteBtn{

  background:#fee2e2;

  color:#dc2626;
}

.deleteBtn:hover{

  background:#dc2626;

  color:white;
}
/* =================================
   PAGE CONTAINER
================================= */

.e2e_hotlist_page{

  background:#ffffff;

  padding:26px;

  border-radius:24px;

  border:1px solid #edf2f7;

  box-shadow:
    0 10px 35px rgba(15,23,42,0.06);
}

/* =================================
   TOP HEADER
================================= */

.e2e_hotlist_top{

  display:flex;

  justify-content:space-between;

  align-items:center;

  margin-bottom:28px;

  gap:20px;

  flex-wrap:wrap;
}

/* LEFT */

.e2e_hotlist_left{

  display:flex;

  flex-direction:column;
}

/* TITLE */

.e2e_hotlist_left h2{

  font-size:28px;

  font-weight:800;

  color:#0f172a;

  margin:0;

  letter-spacing:0.3px;
}

/* UNDERLINE */

.e2e_hotlist_heading_line{

  width:95px;

  height:5px;

  margin-top:12px;

  border-radius:30px;

  background:
    linear-gradient(
      90deg,
      #2563eb,
      #7c3aed
    );
}

/* RIGHT */

.e2e_hotlist_right{

  display:flex;

  align-items:center;
}

/* ADD BUTTON */

.e2e_hotlist_right button{

  border:none;

  background:
    linear-gradient(
      135deg,
      #1677ff,
      #2563eb
    );

  color:white;

  height:46px;

  padding:0 24px;

  border-radius:14px;

  font-size:14px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;

  box-shadow:
    0 8px 20px rgba(37,99,235,0.22);
}

.e2e_hotlist_right button:hover{

  transform:
    translateY(-2px)
    scale(1.02);
}
/* =================================
   FILTER SECTION
================================= */

.e2e_hotlist_filters{

  background:#f8fafc;

  border:1px solid #edf2f7;

  border-radius:20px;

  padding:20px 22px;

  display:flex;

  justify-content:space-between;

  align-items:center;

  gap:24px;

  margin-bottom:28px;
}

/* LEFT SIDE */

.e2e_hotlist_filter_left{

  display:flex;

  align-items:center;

  gap:18px;

  flex-wrap:wrap;
}

/* FILTER GROUP */

.e2e_hotlist_filter_group{

  display:flex;

  align-items:center;

  gap:10px;
}

/* LABEL */

.e2e_hotlist_filter_group label{

  font-size:14px;

  font-weight:700;

  color:#334155;

  white-space:nowrap;
}

/* TEXT */

.e2e_hotlist_filter_group span{

  font-size:14px;

  font-weight:600;

  color:#64748b;
}

/* SELECT */

.e2e_hotlist_filter_group select{

  height:46px;

  min-width:200px;

  padding:0 16px;

  border:1px solid #dbe2ea;

  border-radius:14px;

  outline:none;

  background:white;

  font-size:14px;

  font-weight:600;

  color:#0f172a;

  transition:0.3s ease;

  cursor:pointer;
}

.e2e_hotlist_filter_group select:focus{

  border-color:#2563eb;

  box-shadow:
    0 0 0 4px rgba(37,99,235,0.08);
}

/* SMALL SELECT */

.smallSelect{

  min-width:90px !important;
}

/* REPORT BUTTON */

.e2e_hotlist_report_btn{

  height:46px;

  border:none;

  background:
    linear-gradient(
      135deg,
      #06b6d4,
      #0891b2
    );

  color:white;

  padding:0 22px;

  border-radius:14px;

  font-size:14px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;

  white-space:nowrap;
}

.e2e_hotlist_report_btn:hover{

  transform:translateY(-2px);
}

/* RIGHT SIDE */

.e2e_hotlist_filter_right{

  display:flex;

  align-items:center;

  justify-content:flex-end;
}

/* SEARCH */

.e2e_hotlist_filter_right input{

  width:320px;

  height:46px;

  padding:0 18px;

  border:1px solid #dbe2ea;

  border-radius:14px;

  outline:none;

  background:white;

  font-size:14px;

  font-weight:500;

  transition:0.3s ease;
}

.e2e_hotlist_filter_right input:focus{

  border-color:#2563eb;

  box-shadow:
    0 0 0 4px rgba(37,99,235,0.08);
}
/* =================================
   RESPONSIVE
================================= */

@media screen and (max-width:1100px){

  .e2e_hotlist_filters{

    flex-direction:column;

    align-items:stretch;
  }

  .e2e_hotlist_filter_left{

    width:100%;

    justify-content:space-between;
  }

  .e2e_hotlist_filter_right{

    width:100%;
  }

  .e2e_hotlist_filter_right input{

    width:100%;
  }

}

@media screen and (max-width:768px){

  .e2e_hotlist_page{

    padding:18px;
  }

  .e2e_hotlist_top{

    flex-direction:column;

    align-items:flex-start;
  }

  .e2e_hotlist_left h2{

    font-size:24px;
  }

  .e2e_hotlist_filter_left{

    flex-direction:column;

    align-items:stretch;
  }

  .e2e_hotlist_filter_group{

    width:100%;

    flex-direction:column;

    align-items:flex-start;
  }

  .e2e_hotlist_filter_group select{

    width:100%;
  }

  .e2e_hotlist_report_btn{

    width:100%;
  }

  .e2e_hotlist_table_wrapper table{

    min-width:1100px;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/hotlist.css"],"names":[],"mappings":"AAAA;;mCAEmC;;AAEnC;;EAEE,eAAe;AACjB;;AAEA,UAAU;;AAEV;;EAEE,UAAU;;EAEV,wBAAwB;;EAExB,qBAAqB;AACvB;;AAEA,iBAAiB;;AAEjB;;EAEE,kBAAkB;;EAElB,YAAY;;EAEZ,cAAc;;EAEd,eAAe;;EAEf,wBAAwB;;EAExB,aAAa;;EAEb,4BAA4B;;EAE5B,+BAA+B;;EAE/B,eAAe;AACjB;;AAEA,aAAa;;AAEb;;EAEE,gBAAgB;;EAEhB,oBAAoB;;EAEpB;kCACgC;AAClC;;AAEA;;EAEE,0BAA0B;;EAE1B;mCACiC;AACnC;;AAEA,gBAAgB;;AAEhB;;EAEE,iBAAiB;;EAEjB,qBAAqB;;EAErB,cAAc;;EAEd,aAAa;;EAEb,eAAe;;EAEf,4BAA4B;;EAE5B,+BAA+B;AACjC;;AAEA,kBAAkB;;AAElB;;EAEE,UAAU;;EAEV,iBAAiB;;EAEjB,eAAe;;EAEf,aAAa;AACf;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,SAAS;;EAET,aAAa;;EAEb,eAAe;AACjB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,WAAW;;EAEX,iBAAiB;AACnB;;AAEA,WAAW;;AAEX;;EAEE,6BAA6B;;EAE7B,2BAA2B;;EAE3B,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;;EAE9B,4BAA4B;;EAE5B,+BAA+B;AACjC;;AAEA,YAAY;;AAEZ;;EAEE,YAAY;;EAEZ,qBAAqB;;EAErB,QAAQ;AACV;;AAEA;;EAEE,QAAQ;;EAER,eAAe;;EAEf,aAAa;AACf;;AAEA;;EAEE,aAAa;;EAEb,eAAe;AACjB;;AAEA,aAAa;;AAEb;;EAEE,YAAY;;EAEZ,qBAAqB;;EAErB,QAAQ;AACV;;AAEA;;EAEE,QAAQ;;EAER,eAAe;;EAEf,aAAa;AACf;;AAEA;;EAEE,aAAa;;EAEb,eAAe;AACjB;;AAEA,YAAY;;AAEZ;;EAEE,YAAY;;EAEZ,qBAAqB;;EAErB,kBAAkB;;EAElB,sBAAsB;;EAEtB,QAAQ;AACV;;AAEA,YAAY;;AAEZ;;;;EAIE,WAAW;;EAEX,UAAU;;EAEV,WAAW;;EAEX,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;AACtB;;AAEA,SAAS;;AAET;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA,SAAS;;AAET;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA,WAAW;;AAEX;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;AACA;;mCAEmC;;AAEnC;;EAEE,kBAAkB;;EAElB,YAAY;;EAEZ,kBAAkB;;EAElB,wBAAwB;;EAExB;mCACiC;AACnC;;AAEA;;mCAEmC;;AAEnC;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA,SAAS;;AAET;;EAEE,YAAY;;EAEZ,qBAAqB;AACvB;;AAEA,UAAU;;AAEV;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,QAAQ;;EAER,oBAAoB;AACtB;;AAEA,cAAc;;AAEd;;EAEE,UAAU;;EAEV,UAAU;;EAEV,eAAe;;EAEf,kBAAkB;;EAElB;;;;;KAKG;AACL;;AAEA,UAAU;;AAEV;;EAEE,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;;EAEE,WAAW;;EAEX;;;;;KAKG;;EAEH,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;;EAEpB;mCACiC;AACnC;;AAEA;;EAEE;;eAEa;AACf;AACA;;mCAEmC;;AAEnC;;EAEE,kBAAkB;;EAElB,wBAAwB;;EAExB,kBAAkB;;EAElB,iBAAiB;;EAEjB,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,QAAQ;;EAER,kBAAkB;AACpB;;AAEA,cAAc;;AAEd;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;AACV;;AAEA,UAAU;;AAEV;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,kBAAkB;AACpB;;AAEA,SAAS;;AAET;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,eAAe;;EAEf,cAAc;;EAEd,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ,gBAAgB;;EAEhB,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,oBAAoB;;EAEpB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;;EAEpB;kCACgC;AAClC;;AAEA,iBAAiB;;AAEjB;;EAEE,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB;;EAEE,WAAW;;EAEX,WAAW;;EAEX;;;;;KAKG;;EAEH,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;;EAEpB,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,eAAe;;AAEf;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,wBAAwB;AAC1B;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ,gBAAgB;;EAEhB,cAAc;;EAEd,eAAe;;EAEf,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;;EAEpB;kCACgC;AAClC;AACA;;mCAEmC;;AAEnC;;EAEE;;IAEE,qBAAqB;;IAErB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;;IAEV,6BAA6B;EAC/B;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;AAEF;;AAEA;;EAEE;;IAEE,YAAY;EACd;;EAEA;;IAEE,qBAAqB;;IAErB,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;;IAErB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;;IAEV,qBAAqB;;IAErB,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;EAClB;;AAEF","sourcesContent":["/* =================================\r\n   TABLE\r\n================================= */\r\n\r\n.e2e_hotlist_table_wrapper{\r\n\r\n  overflow-x:auto;\r\n}\r\n\r\n/* TABLE */\r\n\r\n.e2e_hotlist_table_wrapper table{\r\n\r\n  width:100%;\r\n\r\n  border-collapse:separate;\r\n\r\n  border-spacing:0 14px;\r\n}\r\n\r\n/* TABLE HEADER */\r\n\r\n.e2e_hotlist_table_wrapper thead th{\r\n\r\n  background:#f8fafc;\r\n\r\n  padding:18px;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:800;\r\n\r\n  text-transform:uppercase;\r\n\r\n  color:#475569;\r\n\r\n  border-top:1px solid #e2e8f0;\r\n\r\n  border-bottom:1px solid #e2e8f0;\r\n\r\n  text-align:left;\r\n}\r\n\r\n/* BODY ROW */\r\n\r\n.e2e_hotlist_table_wrapper tbody tr{\r\n\r\n  background:white;\r\n\r\n  transition:0.3s ease;\r\n\r\n  box-shadow:\r\n    0 4px 15px rgba(15,23,42,0.04);\r\n}\r\n\r\n.e2e_hotlist_table_wrapper tbody tr:hover{\r\n\r\n  transform:translateY(-2px);\r\n\r\n  box-shadow:\r\n    0 10px 24px rgba(15,23,42,0.08);\r\n}\r\n\r\n/* TABLE CELLS */\r\n\r\n.e2e_hotlist_table_wrapper td{\r\n\r\n  padding:20px 18px;\r\n\r\n  vertical-align:middle;\r\n\r\n  font-size:14px;\r\n\r\n  color:#1e293b;\r\n\r\n  font-weight:600;\r\n\r\n  border-top:1px solid #f1f5f9;\r\n\r\n  border-bottom:1px solid #f1f5f9;\r\n}\r\n\r\n/* COLUMN WIDTHS */\r\n\r\n.e2e_hotlist_table_wrapper td:nth-child(1){\r\n\r\n  width:60px;\r\n\r\n  text-align:center;\r\n\r\n  font-weight:800;\r\n\r\n  color:#2563eb;\r\n}\r\n\r\n.e2e_hotlist_table_wrapper td:nth-child(2){\r\n\r\n  width:34%;\r\n}\r\n\r\n.e2e_hotlist_table_wrapper td:nth-child(3){\r\n\r\n  width:22%;\r\n\r\n  color:#0f172a;\r\n\r\n  font-weight:700;\r\n}\r\n\r\n.e2e_hotlist_table_wrapper td:nth-child(4){\r\n\r\n  width:25%;\r\n}\r\n\r\n.e2e_hotlist_table_wrapper td:nth-child(5){\r\n\r\n  width:140px;\r\n\r\n  text-align:center;\r\n}\r\n\r\n/* RADIUS */\r\n\r\n.e2e_hotlist_table_wrapper tbody tr td:first-child{\r\n\r\n  border-left:1px solid #f1f5f9;\r\n\r\n  border-top-left-radius:18px;\r\n\r\n  border-bottom-left-radius:18px;\r\n}\r\n\r\n.e2e_hotlist_table_wrapper tbody tr td:last-child{\r\n\r\n  border-right:1px solid #f1f5f9;\r\n\r\n  border-top-right-radius:18px;\r\n\r\n  border-bottom-right-radius:18px;\r\n}\r\n\r\n/* DETAILS */\r\n\r\n.e2e_hotlist_details{\r\n\r\n  display:flex;\r\n\r\n  flex-direction:column;\r\n\r\n  gap:10px;\r\n}\r\n\r\n.e2e_hotlist_details p{\r\n\r\n  margin:0;\r\n\r\n  line-height:1.5;\r\n\r\n  color:#475569;\r\n}\r\n\r\n.e2e_hotlist_details strong{\r\n\r\n  color:#0f172a;\r\n\r\n  margin-left:6px;\r\n}\r\n\r\n/* LOCATION */\r\n\r\n.e2e_hotlist_location{\r\n\r\n  display:flex;\r\n\r\n  flex-direction:column;\r\n\r\n  gap:12px;\r\n}\r\n\r\n.e2e_hotlist_location p{\r\n\r\n  margin:0;\r\n\r\n  line-height:1.5;\r\n\r\n  color:#475569;\r\n}\r\n\r\n.e2e_hotlist_location strong{\r\n\r\n  color:#0f172a;\r\n\r\n  margin-left:6px;\r\n}\r\n\r\n/* ACTIONS */\r\n\r\n.e2e_hotlist_actions{\r\n\r\n  display:flex;\r\n\r\n  flex-direction:column;\r\n\r\n  align-items:center;\r\n\r\n  justify-content:center;\r\n\r\n  gap:10px;\r\n}\r\n\r\n/* BUTTONS */\r\n\r\n.viewBtn,\r\n.editBtn,\r\n.deleteBtn{\r\n\r\n  border:none;\r\n\r\n  width:90px;\r\n\r\n  height:38px;\r\n\r\n  border-radius:12px;\r\n\r\n  font-size:12px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n/* VIEW */\r\n\r\n.viewBtn{\r\n\r\n  background:#dbeafe;\r\n\r\n  color:#2563eb;\r\n}\r\n\r\n.viewBtn:hover{\r\n\r\n  background:#2563eb;\r\n\r\n  color:white;\r\n}\r\n\r\n/* EDIT */\r\n\r\n.editBtn{\r\n\r\n  background:#fef3c7;\r\n\r\n  color:#d97706;\r\n}\r\n\r\n.editBtn:hover{\r\n\r\n  background:#f59e0b;\r\n\r\n  color:white;\r\n}\r\n\r\n/* DELETE */\r\n\r\n.deleteBtn{\r\n\r\n  background:#fee2e2;\r\n\r\n  color:#dc2626;\r\n}\r\n\r\n.deleteBtn:hover{\r\n\r\n  background:#dc2626;\r\n\r\n  color:white;\r\n}\r\n/* =================================\r\n   PAGE CONTAINER\r\n================================= */\r\n\r\n.e2e_hotlist_page{\r\n\r\n  background:#ffffff;\r\n\r\n  padding:26px;\r\n\r\n  border-radius:24px;\r\n\r\n  border:1px solid #edf2f7;\r\n\r\n  box-shadow:\r\n    0 10px 35px rgba(15,23,42,0.06);\r\n}\r\n\r\n/* =================================\r\n   TOP HEADER\r\n================================= */\r\n\r\n.e2e_hotlist_top{\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  margin-bottom:28px;\r\n\r\n  gap:20px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* LEFT */\r\n\r\n.e2e_hotlist_left{\r\n\r\n  display:flex;\r\n\r\n  flex-direction:column;\r\n}\r\n\r\n/* TITLE */\r\n\r\n.e2e_hotlist_left h2{\r\n\r\n  font-size:28px;\r\n\r\n  font-weight:800;\r\n\r\n  color:#0f172a;\r\n\r\n  margin:0;\r\n\r\n  letter-spacing:0.3px;\r\n}\r\n\r\n/* UNDERLINE */\r\n\r\n.e2e_hotlist_heading_line{\r\n\r\n  width:95px;\r\n\r\n  height:5px;\r\n\r\n  margin-top:12px;\r\n\r\n  border-radius:30px;\r\n\r\n  background:\r\n    linear-gradient(\r\n      90deg,\r\n      #2563eb,\r\n      #7c3aed\r\n    );\r\n}\r\n\r\n/* RIGHT */\r\n\r\n.e2e_hotlist_right{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n}\r\n\r\n/* ADD BUTTON */\r\n\r\n.e2e_hotlist_right button{\r\n\r\n  border:none;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #1677ff,\r\n      #2563eb\r\n    );\r\n\r\n  color:white;\r\n\r\n  height:46px;\r\n\r\n  padding:0 24px;\r\n\r\n  border-radius:14px;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n\r\n  box-shadow:\r\n    0 8px 20px rgba(37,99,235,0.22);\r\n}\r\n\r\n.e2e_hotlist_right button:hover{\r\n\r\n  transform:\r\n    translateY(-2px)\r\n    scale(1.02);\r\n}\r\n/* =================================\r\n   FILTER SECTION\r\n================================= */\r\n\r\n.e2e_hotlist_filters{\r\n\r\n  background:#f8fafc;\r\n\r\n  border:1px solid #edf2f7;\r\n\r\n  border-radius:20px;\r\n\r\n  padding:20px 22px;\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  gap:24px;\r\n\r\n  margin-bottom:28px;\r\n}\r\n\r\n/* LEFT SIDE */\r\n\r\n.e2e_hotlist_filter_left{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:18px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* FILTER GROUP */\r\n\r\n.e2e_hotlist_filter_group{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:10px;\r\n}\r\n\r\n/* LABEL */\r\n\r\n.e2e_hotlist_filter_group label{\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  color:#334155;\r\n\r\n  white-space:nowrap;\r\n}\r\n\r\n/* TEXT */\r\n\r\n.e2e_hotlist_filter_group span{\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#64748b;\r\n}\r\n\r\n/* SELECT */\r\n\r\n.e2e_hotlist_filter_group select{\r\n\r\n  height:46px;\r\n\r\n  min-width:200px;\r\n\r\n  padding:0 16px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:14px;\r\n\r\n  outline:none;\r\n\r\n  background:white;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#0f172a;\r\n\r\n  transition:0.3s ease;\r\n\r\n  cursor:pointer;\r\n}\r\n\r\n.e2e_hotlist_filter_group select:focus{\r\n\r\n  border-color:#2563eb;\r\n\r\n  box-shadow:\r\n    0 0 0 4px rgba(37,99,235,0.08);\r\n}\r\n\r\n/* SMALL SELECT */\r\n\r\n.smallSelect{\r\n\r\n  min-width:90px !important;\r\n}\r\n\r\n/* REPORT BUTTON */\r\n\r\n.e2e_hotlist_report_btn{\r\n\r\n  height:46px;\r\n\r\n  border:none;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #06b6d4,\r\n      #0891b2\r\n    );\r\n\r\n  color:white;\r\n\r\n  padding:0 22px;\r\n\r\n  border-radius:14px;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n\r\n  white-space:nowrap;\r\n}\r\n\r\n.e2e_hotlist_report_btn:hover{\r\n\r\n  transform:translateY(-2px);\r\n}\r\n\r\n/* RIGHT SIDE */\r\n\r\n.e2e_hotlist_filter_right{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  justify-content:flex-end;\r\n}\r\n\r\n/* SEARCH */\r\n\r\n.e2e_hotlist_filter_right input{\r\n\r\n  width:320px;\r\n\r\n  height:46px;\r\n\r\n  padding:0 18px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:14px;\r\n\r\n  outline:none;\r\n\r\n  background:white;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:500;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_hotlist_filter_right input:focus{\r\n\r\n  border-color:#2563eb;\r\n\r\n  box-shadow:\r\n    0 0 0 4px rgba(37,99,235,0.08);\r\n}\r\n/* =================================\r\n   RESPONSIVE\r\n================================= */\r\n\r\n@media screen and (max-width:1100px){\r\n\r\n  .e2e_hotlist_filters{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:stretch;\r\n  }\r\n\r\n  .e2e_hotlist_filter_left{\r\n\r\n    width:100%;\r\n\r\n    justify-content:space-between;\r\n  }\r\n\r\n  .e2e_hotlist_filter_right{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_hotlist_filter_right input{\r\n\r\n    width:100%;\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width:768px){\r\n\r\n  .e2e_hotlist_page{\r\n\r\n    padding:18px;\r\n  }\r\n\r\n  .e2e_hotlist_top{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:flex-start;\r\n  }\r\n\r\n  .e2e_hotlist_left h2{\r\n\r\n    font-size:24px;\r\n  }\r\n\r\n  .e2e_hotlist_filter_left{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:stretch;\r\n  }\r\n\r\n  .e2e_hotlist_filter_group{\r\n\r\n    width:100%;\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:flex-start;\r\n  }\r\n\r\n  .e2e_hotlist_filter_group select{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_hotlist_report_btn{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_hotlist_table_wrapper table{\r\n\r\n    min-width:1100px;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
